
import ls from 'localstorage-slim'

export const verifyTokenExpire = () => {
    const rawExpireDate = ls.get('date_expire');

    if (!rawExpireDate) {
        return false;
    }

    const now = new Date();
    const expireDate = new Date(rawExpireDate);

    if (isNaN(expireDate.getTime())) {
        return false;
    }

    return now <= expireDate;
}

export const verifyTokenMinutes = ()  => {
    let now = new Date();
    let expireDate = new Date(ls.get('date_expire'));
    let diffInMinutes = Math.floor((expireDate - now) / 1000 / 60);
    if(diffInMinutes <= 5){  // Si le nombre de minutes restant <= 5, alors on rafraichit le token
        return true;
    }
    return false;
}
